export enum AuthMethod {
  EMAIL = 'email',
  WHATSAPP = 'whatsapp',
  AUTHENTICATOR = 'authenticator'
}
